// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2s8gw","cell":"ColumnAccessor_cell__1CZ4r","firstCellAccent":"ColumnAccessor_firstCellAccent__6dXRx"};